module.exports = __webpack_public_path__ + "static/media/onboarding-top.84e870b5.svg";